
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Ebene 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 531 228"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M134.19 88.08v139.46H76V88.08zM254.79.77v84.91L340.55.77h190.3v52.58h-97.57v34.71h-58.22V45l-68 67.19 68 68.77v-44.65h58.22v35.48h97.57v55.75h-190.3l-85.76-85.1v85.1h-59.71V53.35H.79V.77zm264.15 87.3v48.24h-85.66V88.07z","fill":"#fff"}})])
          )
        }
      }
    